import type { TimeSlotMenu } from '../types/timeSlots';

/**
 * Match by `areasWhereItIsOffered` (every area the menu is bookable in); the
 * scalar `menu.area` holds only one area and excludes the menu from the others
 * in the "Any area" flow. Falls back to `menu.area` when the array is absent.
 */
export function menuMatchesArea(
  menu: TimeSlotMenu,
  area: { id: string | number; name: string },
): boolean {
  if (menu.areasWhereItIsOffered && menu.areasWhereItIsOffered.length > 0) {
    return menu.areasWhereItIsOffered.some((a) => String(a.id) === String(area.id));
  }
  return String(menu.area) === String(area.id) || menu.area === area.name;
}

/**
 * Filter a slot's enabled menus to those offered in the given area.
 */
export function filterSlotMenusByArea(
  menus: TimeSlotMenu[],
  area: { id: string | number; name: string },
): TimeSlotMenu[] {
  return menus.filter((m) => menuMatchesArea(m, area));
}
